import { registerView, ViewComponent, preventDefault } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Form, Col, Button, Modal, HeaderRow, LoaderOverlay } from "@emanprague/ppaskit";
import { Input } from "@frui.ts/bootstrap";
import AttachmentCreateViewModel from "viewModels/dashboard/attachments/attachmentCreateViewModel";
import Uploader from "controls/uploader";

const attachmentCreateView: ViewComponent<AttachmentCreateViewModel> = observer(({ vm }) => (
  <>
    <Modal centered show onHide={vm.requestClose}>
      <Modal.Header closeButton>
        <HeaderRow title={vm.name} level={2} size="display-4" />
      </Modal.Header>
      <LoaderOverlay loading={vm.busyWatcher.isBusy}>
        <Modal.Body>
          <Form className="modal-form" onSubmit={preventDefault(vm.confirmChange)}>
            <Form.Row className="form-row-centered">
              <Form.Group as={Col} xs={11}>
                <Form.Label>
                  {vm.translate("file_name")} <span className="text-muted">{vm.translateGeneral("not_mandatory")}</span>
                </Form.Label>
                <Input target={vm.data} property="title" />
              </Form.Group>
              <Form.Group as={Col} xs={11}>
                <Form.Label>
                  {vm.translate("file_description")} <span className="text-muted">{vm.translateGeneral("not_mandatory")}</span>
                </Form.Label>
                <Input target={vm.data} property="description" />
              </Form.Group>

              <Form.Group as={Col} xs={11} className="mt-4 mb-3" controlId="dropzone">
                <Form.Label className="mb-3">
                  <strong>{vm.translate("upload_file")}</strong>
                </Form.Label>
                <Uploader
                  localization={vm.localization}
                  onDrop={vm.onDrop}
                  onDropRejected={vm.onDropRejected}
                  fileSelectError={vm.uploaderErrorMessage}
                  maxFiles={1}
                  maxFileSizeInBytes={5000000}
                  customTypes={vm.translate("uploader_types")}
                />
              </Form.Group>
            </Form.Row>

            {vm.errorMessage && <Form.Control.Feedback type="invalid">{vm.errorMessage}</Form.Control.Feedback>}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="order-2" disabled={!vm.canConfirm} onClick={vm.confirmChange}>
            {vm.translate("upload_button")}
          </Button>
          <Button onClick={vm.requestClose} variant="secondary" className="order-1">
            {vm.translateGeneral("cancel_button")}
          </Button>
        </Modal.Footer>
      </LoaderOverlay>
    </Modal>
  </>
));

registerView(attachmentCreateView, AttachmentCreateViewModel);
